import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectOption } from 'src/app/modules/mypurchase-form/item-vendor/item-list/add-item/item-budget/item-budget.component';
import { DropDownOptions } from 'src/app/shared/models/app-models';

@Component({
  selector: 'app-radio-options',
  templateUrl: './radio-options.component.html',
  styleUrls: ['./radio-options.component.scss'],
})
export class RadioOptionsComponent {
  @Input() control!: FormControl;
  @Input() options!: any[];
  @Input() isColumn: boolean = true;
  @Input() condition: string = '0';
  @Input() filtering: boolean = false;
  @Input() isReadOnly: boolean = false;

  compareWithFn(options: any, selectedOption: any) {
    console.log('compare with called');
    return options && selectedOption && options.id === selectedOption.id;
  }
}
